import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/images/logo.svg'
import _imports_1 from '@/assets/images/icon-cart.svg'


const _hoisted_1 = { class: "nav__logo nav__logo-desktop" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo-svg"
}, null, -1)
const _hoisted_3 = { class: "nav__links" }
const _hoisted_4 = { class: "nav__cart nav__cart--desktop" }
const _hoisted_5 = { class: "nav__cartShopping nav__cartShopping--desktop" }
const _hoisted_6 = { class: "avatar__icon" }
const _hoisted_7 = {
  key: 0,
  class: "auth"
}
const _hoisted_8 = {
  key: 0,
  class: "nav__miniCard nav__miniCard--desktop"
}
const _hoisted_9 = { class: "nav__mobile" }
const _hoisted_10 = { class: "nav__container" }
const _hoisted_11 = { class: "nav__mobileContainer" }
const _hoisted_12 = {
  key: 0,
  class: "nav__mobileLinksContainer"
}
const _hoisted_13 = { class: "nav__mobileLinks" }
const _hoisted_14 = { class: "nav__linksMobile" }
const _hoisted_15 = { class: "nav__logo nav__logo--mobile" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo-svg"
}, null, -1)
const _hoisted_17 = { class: "nav__cart" }
const _hoisted_18 = { class: "nav__cartShopping" }
const _hoisted_19 = {
  key: 0,
  class: "nav__cartNumber"
}
const _hoisted_20 = { class: "nav__avatarImg" }
const _hoisted_21 = {
  key: 0,
  class: "auth"
}
const _hoisted_22 = {
  key: 0,
  class: "nav__miniCard"
}
const _hoisted_23 = {
  key: 0,
  class: "auth"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_AccountAuth = _resolveComponent("AccountAuth")!
  const _component_MiniCard = _resolveComponent("MiniCard")!
  const _component_ModalAuth = _resolveComponent("ModalAuth")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(_ctx.active ? 'nav nav-mobile nav--active' : 'nav nav--mobile')
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.active ? 'nav__desktop nav__desktop--active' : 'nav__desktop'),
      ref: "navBar"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _createElementVNode("nav", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/Collections",
          class: "nav__link nav__link--noSpace"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Collections")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/Men",
          class: "nav__link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Men")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/Women",
          class: "nav__link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Women")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/",
          class: "nav__link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("About")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/",
          class: "nav__link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Contact")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: "icon-cart",
            class: "nav__shoppingIconCart",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeMiniCard && _ctx.changeMiniCard(...args)))
          }),
          (_ctx.shoes.length > 0)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "nav__cartNumber nav__cartNumber--desktop",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeMiniCard && _ctx.changeMiniCard(...args)))
              }, _toDisplayString(_ctx.shoes.length), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_icon, {
            name: "pr-user",
            fill: "#69707D",
            scale: "1.5",
            class: "avatar__Icon",
            onClick: _ctx.changeModalAuth
          }, null, 8, ["onClick"]),
          (_ctx.isModalAuth && _ctx.isLogin)
            ? (_openBlock(), _createElementBlock("article", _hoisted_7, [
                _createVNode(_component_AccountAuth)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.showMiniCard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_MiniCard)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.showMenu ? 'hambu hambu--active' : 'hambu'),
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
          }, null, 2),
          (_ctx.showMenu)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("nav", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      to: "/Collections",
                      class: "nav__linkMobile"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Collections")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      to: "/Men",
                      class: "nav__linkMobile"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Men")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      to: "/Women",
                      class: "nav__linkMobile"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Women")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      to: "/",
                      class: "nav__linkMobile"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("About")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      to: "/",
                      class: "nav__linkMobile"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Contact")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: "icon-cart",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeMiniCard && _ctx.changeMiniCard(...args)))
          }),
          (_ctx.shoes.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.shoes.length), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_v_icon, {
            name: "pr-user",
            fill: "#69707D",
            scale: "1.5",
            class: "avatar__Icon",
            onClick: _ctx.changeModalAuth
          }, null, 8, ["onClick"]),
          (_ctx.isModalAuth && _ctx.isLogin)
            ? (_openBlock(), _createElementBlock("article", _hoisted_21, [
                _createVNode(_component_AccountAuth)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.showMiniCard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createVNode(_component_MiniCard)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isModalAuth && !_ctx.isLogin)
          ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
              _createVNode(_component_ModalAuth)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}